<template>
  <div class="flex flex-col justify-between flex-1">
    <div class="divide-y divide-gray-200">
      <div class="pt-6 pb-5 space-y-6">
        <Form :initial-values="initial_values" :validation-schema="schema" class="mt-2 space-y-6" @submit="assignOwner">
          <div class="-space-y-px rounded-md shadow-sm">
            <ComboBoxInput
              name="owner"
              :items="owners"
              classes="w-full relative dark:text-white"
              label-attr="full_name"
              value-attr="id"
              :value="owner_id"
              :is-box-background="true"
              label="Users"
              :placeholder="$t('Search for team members by name')"
              :show-label="true"
              :floating-label="false"
              :allow-null="false">
              <template #item="{ item, active }">
                <li
                  :class="[
                    active ? 'text-white bg-blue' : 'text-gray-900 dark:text-white',
                    'cursor-default relative py-2 pl-4 pr-4 group'
                  ]">
                  <div class="flex items-center">
                    <img
                      v-if="item.avatar"
                      class="inline-block rounded-full h-9 w-9 object-cover"
                      :src="item.avatar"
                      onerror="this.onerror=null; this.src=window.default_avatar;"
                      alt="">
                    <Avatar v-else :hover-effect="true" :first-name="item.first_name" :last-name="item.last_name" />
                    <div class="ml-3">
                      <p class="h-full text-sm font-normal text-gray-700 dark:text-white group-hover:text-white">
                        {{ Record.from(item).full_name }}
                      </p>
                      {{ Record.from(item).email }}
                    </div>
                  </div>
                </li>
              </template>
            </ComboBoxInput>
          </div>
          <div v-if="isAllRecords" class="flex items-center mb-4 space-x-2 text-status-error-red">
            {{ $t("Confirm assigning to") }} {{ count - excludedRecords.length }} {{ $t("out of") }} {{ count }}
            {{ $t("records in table") }}

            <input
              v-model="confirm_assign_all"
              type="checkbox"
              name="truncate"
              class="ml-2 form-checkbox text-light-brand-blue dark:text-dark-brand-blue checked:bg-light-brand-blue dark:checked:bg-dark-brand-blue bg-light-box-background dark:bg-dark-box-background border-[2px] focus:ring-0 ring-dark/0 border-common-grey w-5 rounded h-5 transition ease-in-out duration-side-menu-transition-duration">
          </div>
          <div class="flex flex-row justify-between w-full gap-2">
            <button type="button" class="w-1/2 m-0 cancel-btn" @click="$emit('cancel')">{{ $t("Cancel") }}</button>
            <button :disabled="isAllRecords && !confirm_assign_all" type="submit" class="w-1/2 primary-btn">
              {{ $t("Assign Owner") }}
            </button>
          </div>
        </Form>
      </div>
    </div>
  </div>
</template>

<script>
import { ALL_EMITTERS } from "@/store/constants/all_emitters"
import { useI18n } from "vue-i18n"
import * as Yup from "yup"
import { Form } from "vee-validate"
import dataService from "@/services/data.service"
import ComboBoxInput from "../shared/ComboBoxInput.vue"
import Avatar from "../shared/Avatar.vue"

import { Record } from "@/models/record"

export default {
  components: {
    Form,
    Avatar,
    ComboBoxInput
  },
  props: {
    count: null,
    filter: null,
    records: null,
    fullRecords: null,
    record: null,
    objectType: {
      type: String,
      required: false
    },
    excludedRecords: {
      type: Array,
      default: () => []
    },
    isAllRecords: {
      type: Boolean,
      default: false
    },
    playbookResults: {
      type: Array,
      default: () => [],
      required: false
    }
  },
  emits: ["cancel", "submitted", "done"],
  setup() {
    const { t } = useI18n()
    const schema = Yup.object().shape({
      owner: Yup.string().required(t("Owner is required"))
      //TODO : the rest of the fields
    })
    const initial_values = {}

    return {
      schema,
      initial_values
    }
  },

  data() {
    return {
      owners: [],
      owner_id: null,
      confirm_assign_all: false,
      Record
    }
  },

  created() {
    this.owners = this.$store.state.data.users
    this.playbookResults.map((r) => {
      this.owners.push({
        ...r,
        full_name: r.label,
        name: r.label,
        first_name: r.label,
        owner_id: r.value
      })
    })
    if (this.fullRecords?.length) {
      let owner = this.fullRecords[0].owner
      let is_all_records_has_the_same_owner = true
      this.fullRecords.map((record) => {
        if (record.owner != owner) {
          is_all_records_has_the_same_owner = false
        }
      })
      if (is_all_records_has_the_same_owner) {
        this.owner_id = owner
      }
    } else {
      this.owner_id = this.record?.owner
    }
  },

  methods: {
    assignOwner(values) {
      let ids = null
      if (this.isAllRecords) {
        ids = []
      } else if (this.records?.length) {
        ids = this.records
      } else {
        ids = [this.record.id]
      }
      if (this.record) {
        let new_record = { ...this.record }
        let owner = this.owners.find((t) => t.id == values["owner"])
        new_record.owner = owner.id

        this.$store.dispatch("ui/setCurrentCompany", new_record)
      }
      let data = {
        ...values,
        records: ids,
        is_all_records: this.isAllRecords,
        excluded_records: this.excludedRecords,
        filter: this.filter,
        object_type: this.objectType
      }

      dataService.assignCompaniesOwner(data).then(() => {
        this.$emit("done")
        this.$emitter.emit(ALL_EMITTERS.REFRESH_TABLE)

        //Update companies table
        if (!this.isAllRecords) {
          if (this.fullRecords?.length) {
            this.fullRecords.forEach((r) => {
              r.owner = values["owner"]
              this.$store.dispatch("data/emitRecordUpdatedEmitters", r)
            })
          } else {
            let r = this.record
            r.owner = values["owner"]
            this.$store.dispatch("data/emitRecordUpdatedEmitters", r)
          }
        }
      })
    }
  }
}
</script>
